export default __webpack_public_path__ + "static/media/layer.bd962069.png";